<template>
  <div class="pemesananApp" id="pemesanan-app">
    <SOSlotBase
      :bg-grey="true"
      :container-name="`pemesananApp`"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Pemesanan App Konsumen'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:content>
        <div class="p-x-4 bg-white" >
	        <div class="bar p-x-20 remove-margin" v-if="isLoading">
		        <div class="keterangan d-flex-between remove-margin">
			        <div class="f-14 f-regular f-c-primary p-t-16 remove-margin">
				        <div class="f-18 f-c-midgrey remove-margin">

				        <h3>Loading...</h3>
				        </div>
			        </div>
		        </div>
	        </div>
	         <cicilan v-else></cicilan>
        </div>
        <div class="p-x-20 p-y-20 bg-white" style="margin-top: 20px">
          <!-- <CardWhitelabel /> -->
<div class="row">
	<div class="col-md-3">
		<div class="card shadow">
			<div class="card-header">
				<p class="label mar-bot-10">SEDANG BERLANGSUNG</p>
				<b class="header-text">Early Bird 1</b>
				<br />
				<b class="price-final-text">RP 75.000.000</b>
				<b class="price-text">RP 5.000.000</b>
				<p class="sub-info remove-margin">
					6x selama 6 bulan
				</p>

			</div>
			<div class="card-body">
				<div class="content-1">
					<p>
						Periode pemesanan: <br />
						November - Desember 2023
					</p>
				</div>
				<div class="content-2">
					<b> Terbatas Untuk 10 Pemesan Pertama </b>
				</div>
				<button
					class="btn btn-long btn-primary width-100 f-c-white"
					@click="hubungiCS"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M12.0398 2C6.5798 2 2.1298 6.45 2.1298 11.91C2.1298 13.66 2.5898 15.36 3.4498 16.86L2.0498 22L7.2998 20.62C8.7498 21.41 10.3798 21.83 12.0398 21.83C17.4998 21.83 21.9498 17.38 21.9498 11.92C21.9498 9.27 20.9198 6.78 19.0498 4.91C18.133 3.98392 17.041 3.24967 15.8374 2.75005C14.6339 2.25043 13.3429 1.99546 12.0398 2ZM12.0498 3.67C14.2498 3.67 16.3098 4.53 17.8698 6.09C18.6354 6.85535 19.2424 7.76431 19.656 8.76476C20.0695 9.7652 20.2815 10.8374 20.2798 11.92C20.2798 16.46 16.5798 20.15 12.0398 20.15C10.5598 20.15 9.1098 19.76 7.8498 19L7.5498 18.83L4.4298 19.65L5.2598 16.61L5.0598 16.29C4.23374 14.9787 3.79682 13.4598 3.7998 11.91C3.8098 7.37 7.4998 3.67 12.0498 3.67ZM8.5298 7.33C8.3698 7.33 8.0998 7.39 7.8698 7.64C7.6498 7.89 6.9998 8.5 6.9998 9.71C6.9998 10.93 7.8898 12.1 7.9998 12.27C8.1398 12.44 9.7598 14.94 12.2498 16C12.8398 16.27 13.2998 16.42 13.6598 16.53C14.2498 16.72 14.7898 16.69 15.2198 16.63C15.6998 16.56 16.6798 16.03 16.8898 15.45C17.0998 14.87 17.0998 14.38 17.0398 14.27C16.9698 14.17 16.8098 14.11 16.5598 14C16.3098 13.86 15.0898 13.26 14.8698 13.18C14.6398 13.1 14.4998 13.06 14.3098 13.3C14.1498 13.55 13.6698 14.11 13.5298 14.27C13.3798 14.44 13.2398 14.46 12.9998 14.34C12.7398 14.21 11.9398 13.95 10.9998 13.11C10.2598 12.45 9.7698 11.64 9.6198 11.39C9.4998 11.15 9.6098 11 9.7298 10.89C9.8398 10.78 9.9998 10.6 10.0998 10.45C10.2298 10.31 10.2698 10.2 10.3498 10.04C10.4298 9.87 10.3898 9.73 10.3298 9.61C10.2698 9.5 9.7698 8.26 9.5598 7.77C9.3598 7.29 9.1598 7.35 8.9998 7.34C8.8598 7.34 8.6998 7.33 8.5298 7.33Z"
							fill="#fff"
						/>
					</svg>
					PESAN SEKARANG
				</button>
			</div>
		</div>
	</div>
	<div class="col-md-3">
		<div class="card shadow">
			<div class="card-header">
				<b class="header-text">Early Bird 2</b>
				<br /><b class="price-final-text">RP 75.000.000</b>
				<b class="price-text">RP 7.500.000</b>
				<p class="sub-info remove-margin">
					6x selama 6 bulan
				</p>
			</div>
			<div class="card-body">
				<div class="content-1">
					<p>
						Periode pemesanan: <br />
						Januari - Februari 2024
					</p>
				</div>
				<div class="content-2">
					<b> Terbatas Untuk 20 Pemesan  </b>

					<!--                <b> Benefit </b>-->
					<!--                <ul>-->
					<!--                  <li>-->
					<!--                    Aplikasi multi platform yang sudah terintegrasi dengan akun-->
					<!--                    Smartlink anda-->
					<!--                  </li>-->
					<!--                  <li>Dapat menerima 300 transaksi per hari</li>-->
					<!--                </ul>-->
				</div>
			</div>
		</div>
	</div>
	<div class="col-md-3">
		<div class="card shadow">
			<div class="card-header">
				<b class="header-text">Early Bird 3</b>
				<br />
				<b class="price-final-text">RP 75.000.000</b>
				<b class="price-text">RP 20.000.000</b>
				<p class="sub-info remove-margin">
					6x selama 6 bulan
				</p>
			</div>
			<div class="card-body">
				<div class="content-1">
					<p>
						Periode pemesanan: <br />
						Maret - April 2024
					</p>
				</div>
				<div class="content-2">
					<b> Terbatas Untuk 20 Pemesan  </b>
					<!--                <ul>-->
					<!--                  <li>-->
					<!--                    Aplikasi multi platform yang sudah terintegrasi dengan akun-->
					<!--                    Smartlink anda-->
					<!--                  </li>-->
					<!--                  <li>Dapat menerima 300 transaksi per hari</li>-->
					<!--                </ul>-->
				</div>
			</div>
		</div>
	</div>
	<div class="col-md-3">
		<div class="card shadow">
			<div class="card-header">
				<b class="header-text">Normal Price</b>
				<br />
				<b class="price-text">RP 75.000.000</b>

				<p class="sub-info remove-margin">
					Dapat dicicil 6x selama 6 bulan
				</p>
			</div>
			<div class="card-body">
				<div class="content-1">
					<p>
						Periode pemesanan: <br />
						Mulai dari Mei 2024
					</p>
				</div>
			</div>
		</div>
	</div>
</div>

          <button
            class="btn btn-long btn-primary width-100 f-c-white"
            @click="hubungiCS"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12.0398 2C6.5798 2 2.1298 6.45 2.1298 11.91C2.1298 13.66 2.5898 15.36 3.4498 16.86L2.0498 22L7.2998 20.62C8.7498 21.41 10.3798 21.83 12.0398 21.83C17.4998 21.83 21.9498 17.38 21.9498 11.92C21.9498 9.27 20.9198 6.78 19.0498 4.91C18.133 3.98392 17.041 3.24967 15.8374 2.75005C14.6339 2.25043 13.3429 1.99546 12.0398 2ZM12.0498 3.67C14.2498 3.67 16.3098 4.53 17.8698 6.09C18.6354 6.85535 19.2424 7.76431 19.656 8.76476C20.0695 9.7652 20.2815 10.8374 20.2798 11.92C20.2798 16.46 16.5798 20.15 12.0398 20.15C10.5598 20.15 9.1098 19.76 7.8498 19L7.5498 18.83L4.4298 19.65L5.2598 16.61L5.0598 16.29C4.23374 14.9787 3.79682 13.4598 3.7998 11.91C3.8098 7.37 7.4998 3.67 12.0498 3.67ZM8.5298 7.33C8.3698 7.33 8.0998 7.39 7.8698 7.64C7.6498 7.89 6.9998 8.5 6.9998 9.71C6.9998 10.93 7.8898 12.1 7.9998 12.27C8.1398 12.44 9.7598 14.94 12.2498 16C12.8398 16.27 13.2998 16.42 13.6598 16.53C14.2498 16.72 14.7898 16.69 15.2198 16.63C15.6998 16.56 16.6798 16.03 16.8898 15.45C17.0998 14.87 17.0998 14.38 17.0398 14.27C16.9698 14.17 16.8098 14.11 16.5598 14C16.3098 13.86 15.0898 13.26 14.8698 13.18C14.6398 13.1 14.4998 13.06 14.3098 13.3C14.1498 13.55 13.6698 14.11 13.5298 14.27C13.3798 14.44 13.2398 14.46 12.9998 14.34C12.7398 14.21 11.9398 13.95 10.9998 13.11C10.2598 12.45 9.7698 11.64 9.6198 11.39C9.4998 11.15 9.6098 11 9.7298 10.89C9.8398 10.78 9.9998 10.6 10.0998 10.45C10.2298 10.31 10.2698 10.2 10.3498 10.04C10.4298 9.87 10.3898 9.73 10.3298 9.61C10.2698 9.5 9.7698 8.26 9.5598 7.77C9.3598 7.29 9.1598 7.35 8.9998 7.34C8.8598 7.34 8.6998 7.33 8.5298 7.33Z"
                fill="#fff"
              />
            </svg>
            Hubungi Marketing Smartlink di 081216457251
          </button>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import CardWhitelabel from "../components/cardwhitelabel";
import Cicilan from "../components/cicilan";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "Whitelabel",
  components: {
    SOSlotBase,
    SOTitleBar,
    CardWhitelabel,
    Cicilan,
  },
  data() {
    return {
      isLoading: false,
      paramnya: "dkekoed",
    };
  },

  async create() {},

  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      whitelabel: "whitelabel",
    }),
  },

  methods: {
    ...mapActions({
      getWhitelabel: `${moduleName}/getWhitelabel`,
      getDetail: `${moduleName}/getDetail`,
    }),
    async init() {
	    this.isLoading=true
      try {
        let res = await this.getWhitelabel();
        // console.log(res);
        if (res.data.code) {
          let data = this.whitelabel[0].id;
          await this.getDetail(data);
	        this.isLoading=false
        }
		this.isLoading=false
      } catch {
	      this.isLoading=false
      }

    },

    hubungiCS() {
			const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
			const link = "https://api.whatsapp.com/send/?phone=+6281216457251&text=Halo%20Saya%20Tertarik%20untuk%20Pre%20Order%20APP%20White%20Label.%20Bisa%20Minta%20Informasinya%20Lebih%20Lanjut?";
			if (this.isWebview() && flutterConfig.platform !== 'web') {
				this.flutterSendWa('6281216457251', 'Halo Saya Tertarik untuk Pre Order APP White Label. Bisa Minta Informasinya Lebih Lanjut?')
			} else {
				window.open(link, '_blank');
			}
    },

    back() {
      this.$router.go("/Dashboad");
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  border-radius: 10px;
}
.card-header {
  color: white;
  background-color: #206cff;
  width: 100%;
  height: auto;
  border-radius: 10px 10px 0px 0px;
}

.card-body {
  border-radius: 0px 0px 10px 10px;
}

.label {
  background-color: #f2924c;
  padding: 3px 4px 0px 4px;
  width: fit-content;
  border-radius: 3px;
  color: #fff;
  font-weight: 600;
}

/* @media screen and (min-width: 800px) and (max-width: 1199px) {
  .pemesananApp .card {
    float: left !important;
    width: calc(50% - 15px) !important;
  }
  .pemesananApp .card:nth-child(even) {
    margin-left: 15px !important;
  }
  .pemesananApp .card:nth-child(odd) {
    margin-right: 15px !important;
  }
} */

/* @media screen and (min-width: 1200px) {
  .pemesananApp .card {
    float: left !important;
    width: calc(25% - 15px) !important;
  }
  .pemesananApp .card {
    margin-left: 15px !important;
  }
  .pemesananApp .card:first-child {
    margin-left: 0px !important;
  }
} */

.pemesananApp .header-text {
  font-size: 16px !important;
}

.pemesananApp .price-text {
  font-size: 28px !important;
}
.pemesananApp .price-final-text {
    display: block;
    text-decoration: line-through;
    text-decoration-color: #dc3545;
    text-decoration-thickness: 3px;
    font-size: 20px;
}

.pemesananApp .card-body .list-text {
  font-size: 14px !important;
}
</style>
